import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Typography } from "antd";
import type { FC } from "react";

import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText } from "@/shared/ui/Typography";

interface WarningModalProps {
    open: boolean;
    onClose: () => void;
    formId: string;
    loading: boolean;
}

export const WarningModal: FC<WarningModalProps> = ({
    onClose,
    open,
    formId,
    loading,
}) => {
    return (
        <BaseModal
            open={open}
            onClose={onClose}
            actions={null}
            mask={{ closable: true }}
        >
            <Flex vertical gap={16}>
                <Flex gap={16} align={"center"}>
                    <InfoCircleOutlined
                        color="error"
                        style={{ fontSize: 16 }}
                    />

                    <PrimaryText fontSize={18} textAlign={"center"}>
                        Увага!
                    </PrimaryText>
                </Flex>

                <Typography>
                    Якщо ви не вкажете &quot;ID торгової точки в обліковому
                    записі партнера&quot;, то по ній не буде працювати обмін
                    продажів та дебіторської заборгованості
                </Typography>

                <Flex vertical gap={8}>
                    <BaseButton
                        size="large"
                        type="default"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Повернутися назад
                    </BaseButton>

                    <BaseButton
                        type="primary"
                        size="large"
                        form={formId}
                        htmlType="submit"
                        loading={loading}
                    >
                        Все одно створити
                    </BaseButton>
                </Flex>
            </Flex>
        </BaseModal>
    );
};
